<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0 snapshotHeader">
        <b-col> </b-col>
        <b-col class="text-right">
          <downloadChart />
        </b-col>
      </b-row>

      <b-row class="m-0 chartTabPanel autoCursor snapShotPanel">
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 1-->
            <b-card header="Fin. Summary" header-tag="header" class="m-2 ">
              <div id="financial_summary_tbl" class="tblWrapper">
                <h5 class="px-2">Financial Summary</h5>
                <table>
                  <thead id="financial_summary_head">
                    <th>Fiscal year end 30-Jun</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="financial_summary_body">
                    <tr
                      v-for="(fitem, Id) in financialTableData"
                      v-bind:key="Id"
                    >
                      <td>{{ fitem["key"] }}</td>
                      <td class="rightAligned">
                        {{ fitem["2016A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ fitem["2017A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ fitem["2018A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ fitem["2019E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ fitem["2020E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ fitem["2021E"] | roundOff }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="key_company_tbl" class="tblWrapper">
                <h5 class="px-2">Key Company Metrics</h5>
                <table>
                  <thead id="key_company_head">
                    <th>Fiscal year end 30-Jun</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="key_company_body">
                    <tr
                      v-for="(item, id) in keycompanyTableData"
                      v-bind:key="id"
                    >
                      <td>{{ item["key"] }}</td>
                      <td class="rightAligned">
                        {{ item["2016A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2017A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2018A"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2019E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2020E"] | roundOffPer }}
                      </td>
                      <td class="rightAligned">
                        {{ item["2021E"] | roundOffPer }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="valuation_tbl" class="tblWrapper">
                <h5 class="px-2">Valuation Metrics</h5>
                <table>
                  <thead id="valuation_head">
                    <th>Fiscal year end 30-Jun</th>
                    <th class="rightAligned">2016A</th>
                    <th class="rightAligned">2017A</th>
                    <th class="rightAligned">2018A</th>
                    <th class="rightAligned">2019E</th>
                    <th class="rightAligned">2020E</th>
                    <th class="rightAligned">2021E</th>
                  </thead>
                  <tbody id="valuation_body">
                    <tr
                      v-for="(vitem, idx) in valuationTableData"
                      v-bind:key="idx"
                    >
                      <td>{{ vitem["key"] }}</td>
                      <td class="rightAligned">
                        {{ vitem["2016A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2017A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2018A"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2019E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2020E"] | roundOff }}
                      </td>
                      <td class="rightAligned">
                        {{ vitem["2021E"] | roundOff }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col ref="capture" cols="6" class="py-0">
          <b-card-group deck>
            <!--Card 2-->
            <b-card
              header="Key Company Metrics"
              header-tag="header"
              class="m-2 "
            >
              <div class="filterBtn row m-0">
                <div class="filterBtn mx-3 my-2">
                  <button
                    class="btn btn-primary btn-xs btnContainer mb-2"
                    v-for="buttonList of key_Company_Metrics"
                    :key="buttonList.name"
                    :class="{ active: buttonList.active }"
                    @click="getKeyChartData(buttonList.name, buttonList.color)"
                  >
                    {{ buttonList.title }}
                  </button>
                </div>
              </div>
              <div
                class="chartWrapper"
                ref="keyCompanyChart"
                id="keyCompanyChart"
              >
                <Plotly
                  :data="keyCompanyChartData"
                  :layout="keyCompanyLayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>

          <b-card-group deck>
            <!--Card 2-->
            <b-card header="Valuation Metrics" header-tag="header" class="m-2 ">
              <div class="filterBtn row m-0">
                <div class="filterBtn mx-3 my-2">
                  <button
                    class="btn btn-primary btn-xs btnContainer1 mb-2"
                    v-for="value of valuation_Metrics"
                    :key="value.name"
                    :name="value.name"
                    :class="{ active: value.active }"
                    @click="getValuationChartData(value.name)"
                  >
                    {{ value.title }}
                  </button>
                </div>
              </div>
              <div
                class="chartWrapper"
                ref="valuationChart"
                id="valuationChart"
              >
                <Plotly
                  :data="valuationData"
                  :layout="Linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </div>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
//import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "snapshot",
  components: {
    Plotly,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      valuationmetrics: "valuationmetrics",
      financialsummary: "financialsummary",
      keycompanymetrics: "keycompanymetrics",
      iMost: "iMost",
      isFullScreen: "isFullScreen",
    }),
    iMostChildren() {
      return this.iMost.child;
    },
    valuationTableData() {
      return this.formatdata(this.valuationmetrics);
    },
    financialTableData() {
      return this.formatdata(this.financialsummary);
    },
    keycompanyTableData() {
      return this.formatdata(this.keycompanymetrics);
    },
  },
  data() {
    return {
      chartTitle: "",
      sliderValue: [2015, 2020],
      min: 2015,
      max: 2020,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      keyChartCalc: true,
      valuationChartCalc: true,
      keyCompanyLayout: {
        title: "",
        width: 620,
        height: 200,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        showlegend: false,
        xaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          fixedrange: true,
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          format: "%",
          fixedrange: true,
          range: [-5, 20],
          nticks: 8,
        },
      },
      keyCompanyChartData: [],
      valuationData: [
        {
          name: "Price/Sales (x)",
          type: "bar",
          x: ["2016A", "2017A", "2018A", "2019E", "2020E", "2021E"],
          y: [3.9, 3.2, 3.2, 3.4, 3.1, 3],
          yaxis: "y",
          marker: { color: "#a6bad3" },
        },
        {
          name: "YoY % Change",
          type: "line",
          x: ["2016A", "2017A", "2018A", "2019E", "2020E", "2021E"],
          y: [0, -17.95, 0, 6.25, -8.82, -3.23],
          marker: { color: "#9bbb59" },
          yaxis: "y2",
        },
      ],
      Linelayout: {
        width: 620,
        height: 200,
        autosize: true,
        margin: {
          l: "auto",
          r: "auto",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        yaxis2: {
          titlefont: { color: "#333" },
          tickfont: { color: "#333" },
          overlaying: "y",
          side: "right",
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          ticksuffix: "%",
          fixedrange: true,
          range: [-20, 10],
          nticks: 5,
        },
        legend: {
          x: 0.2,
          y: -0.3,
          orientation: "h",
        },
      },

      config: { responsive: true },
      key_Company_Metrics: [
        {
          name: "Sales Growth",
          title: "Sales Growth",
          color: "#1f497d",
          active: true,
        },
        {
          name: "EPS Growth",
          title: "EPS Growth",
          color: "#4bacc6",
          active: false,
        },
        {
          name: "EBITDA Margin",
          title: "EBITDA Margin",
          color: "#548cd1",
          active: false,
        },
        {
          name: "EBIT Margin",
          title: "EBIT Margin",
          color: "#c6d6ea",
          active: false,
        },
        {
          name: "ROE",
          title: "ROE",
          color: "#cc3300",
          active: false,
        },
        {
          name: "FCF Yield",
          title: "FCF Yield",
          color: "#cc3300",
          active: false,
        },
      ],
      valuation_Metrics: [
        {
          name: "Price/Sales (x)",
          title: "Price/Sales",
          color: "#1f497d",
          active: true,
        },
        {
          name: "P/E (x)",
          title: "P/E",
          color: "#4bacc6",
          active: false,
        },
        {
          name: "P/BV (x)",
          title: "P/BV",
          color: "#548cd1",
          active: false,
        },
        {
          name: "EV/Sales",
          title: "EV/Sales",
          color: "#c6d6ea",
          active: false,
        },
        {
          name: "EV/EBITDA",
          title: "EV/EBITDA",
          color: "#cc3300",
          active: false,
        },
        {
          name: "EV/EBIT",
          title: "EV/EBIT",
          color: "#cc3300",
          active: false,
        },
      ],
    };
  },
  created() {
    window.addEventListener("resize", this.windowResize);
    let filterChart = this.iMostChildren.filter(
      (item) => "Snapshot" === item.objectname
    );
    // console.log('filterChart Snapshot-==',filterChart);
    let snapshopChild = filterChart[0].child;
    for (var i = 0; i < snapshopChild.length; i++) {
      this.getChartDataById({
        id: snapshopChild[i].chartId,
        chartName: snapshopChild[i].objectname,
      });
    }
  },
  methods: {
    ...mapActions(["setDownloadInfo", "getChartDataById"]),
    windowResize(e) {
      this.Linelayout.width = this.$refs.keyCompanyChart.clientWidth - 50;
    },
    formatdata(mapData) {
      let tableData = [];
      if (
        typeof mapData.category != "undefined" &&
        mapData.category.length > 0
      ) {
        for (var i = 0; i < mapData.category.length; i++) {
          tableData.push({ key: mapData.category[i] });
          for (var j = 0; j < mapData.xaxis.length; j++) {
            let cat = mapData.category[i].toLowerCase().replace(/\s/g, "");
            tableData[i][mapData.xaxis[j]] = mapData[cat][j];
          }
        }
      }
      if (tableData.length > 0) {
        if (this.keyChartCalc) {
          this.keyChartCalc = false;
          this.getKeyChartData("Sales Growth", "#1f497d");
        }
        if (this.valuationChartCalc) {
          this.valuationChartCalc = false;
          this.getValuationChartData("Price/Sales (x)");
        }
      }

      return tableData;
    },
    getKeyChartData(filter, lineColor) {
      let keyCompanyDefaultData = JSON.parse(
        sessionStorage.getItem("keycompanymetrics")
      );
      let valuationChart = JSON.parse(
        sessionStorage.getItem("valuationmetrics")
      );
      // console.log('keyCompanyDefaultData-==--=',keyCompanyDefaultData);
      let chartData = [
        {
          line: { color: lineColor },
          mode: "Line",
          name: "",
          y: [],
          x: [],
        },
      ];

      if (filter === "FCF Yield") {
        // console.log('valuationmetrics-=--==',valuationChart);
        chartData[0].x = valuationChart.xaxis;
        chartData[0].y = valuationChart["fcfyield(%)"].map(function(num) {
          return Number(num.replace("%", ""));
        });
        let maxVal = Math.max(chartData[0].y);
        let minVal = Math.min(chartData[0].y);
        this.keyCompanyLayout.yaxis.range[0] = minVal;
        this.keyCompanyLayout.yaxis.range[1] = maxVal;
      } else {
        chartData[0].x = keyCompanyDefaultData.xaxis;

        chartData[0].y = keyCompanyDefaultData[
          filter.replace(/\s/g, "").toLowerCase()
        ].map(function(num) {
          return Number(num.replace("%", ""));
        });
        let maxVal = Math.max(chartData[0].y);
        let minVal = Math.min(chartData[0].y);
        this.keyCompanyLayout.yaxis.range[0] = minVal;
        this.keyCompanyLayout.yaxis.range[1] = maxVal;
      }

      chartData[0].name = filter;

      this.keyCompanyChartData = [];
      this.keyCompanyChartData = chartData;
      // console.log('this.keyCompanyChartData-=-=-=',this.keyCompanyChartData);
      this.key_Company_Metrics.forEach((buttonList) => {
        if (buttonList.name === filter) {
          buttonList.active = true;
        } else {
          buttonList.active = false;
        }
      });
    },
    getValuationChartData(filter) {
      this.valuationData[0].name = filter;
      let valuationChart = JSON.parse(
        sessionStorage.getItem("valuationmetrics")
      );

      this.valuationData[0].x = valuationChart.xaxis;
      this.valuationData[0].y = [];
      // console.log('filter data--',valuationChart[filter.toLowerCase().replace(/\s/g, '')]);
      this.valuationData[0].y =
        valuationChart[filter.toLowerCase().replace(/\s/g, "")];

      let maxVal = Math.max(this.valuationData[0].y);
      let minVal = Math.min(this.valuationData[0].y);
      this.Linelayout.yaxis.range[0] = minVal;
      this.Linelayout.yaxis.range[1] = maxVal;
      this.valuationData[1].x = valuationChart.xaxis;
      let yoyData = valuationChart[filter.toLowerCase().replace(/\s/g, "")];
      this.valuationData[1].y = [];
      for (let i = 0; i < yoyData.length; i++) {
        let yoy = 0;
        if (i > 0) {
          yoy = (
            ((yoyData[i] - yoyData[i - 1]) / yoyData[i - 1]) *
            100
          ).toFixed(1);
        }
        this.valuationData[1].y.push(yoy);
      }
      let maxValYoY = Math.max(this.valuationData[1].y);
      let minValYoY = Math.min(this.valuationData[1].y);
      this.Linelayout.yaxis2.range[0] = minValYoY;
      this.Linelayout.yaxis2.range[1] = maxValYoY;
      // console.log('valuation data-==-=-',this.valuationData);
      this.valuation_Metrics.forEach((buttonList) => {
        if (buttonList.name === filter) {
          buttonList.active = true;
        } else {
          buttonList.active = false;
        }
      });
    },
  },
  mounted() {
    let filterChart = this.iMostChildren.filter(
      (item) => "Snapshot" === item.objectname
    );
    // console.log('filterChart-==',filterChart);
    let snapshopChild = filterChart[0].child;
    for (var i = 0; i < snapshopChild.length; i++) {
      this.getChartDataById({
        id: snapshopChild[i].chartId,
        chartName: snapshopChild[i].objectname,
      });
    }

    this.setDownloadInfo({
      fileName: "Snapshot",
      downloadData: this.$refs.capture,
    });
    this.getKeyChartData("Sales Growth", "#1f497d");
    this.getValuationChartData("Price/Sales (x)");
  },
  filters: {
    roundOff(num) {
      return num;
    },
    roundOffPer(num) {
      return isNaN(num) ? num : (num * 100).toFixed(1) + "%";
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
};
</script>

<style lang="scss">
.tblWrapper {
  margin-bottom: 12px;
}
.tblWrapper h5 {
  font-size: 1rem;
  padding-top: 10px;
}
.tblWrapper table {
  border: 1px solid;
  position: relative;
  width: 100%;
  font-size: 11px;
  border: none;
}
.tblWrapper table thead {
  width: 100%;
  background: #fff;
  color: #333;
  text-align: left;
  font-size: 11px;
}
.snapShotPanel {
  max-height: 45vh;
  overflow: auto;
}
.fullscreen .snapShotPanel {
  max-height: 98vh !important;
  overflow: auto;
}
.snapShotPanel .card-header {
  padding: 0rem 0.2rem;
  font-size: 0.9rem;
}
.rightAligned {
  text-align: right;
}
.snapShotPanel .card-body {
  padding: 0.25rem;
}
.snapshotHeader .exportDropDown .btn,
.snapshotHeader .fullscreenBtn {
  padding: 0 5px;
}
.snapShotPanel .filterBtn .btn {
  margin-right: 5px;
  padding: 0.2rem 0.5rem !important;
  font-size: 0.9rem;
}
.snapShotPanel .filterBtn {
  margin: 0 auto;
}
.chartTabPanel.autoCursor.snapShotPanel {
  table th,
  table td {
    padding: 0 0.5rem;
  }
}
</style>
